export default "__VITE_ASSET__e4ae75db__"